<!--顶-->
<template>
  <div class="order-container light-bg" ref="order">
    <titleHeader title="我的订单"  ref="order_header_title" :cunstom-back="true" @goback="goback" @load-success="loadHeaderSuccess"></titleHeader>
    <div class="order-header" ref="order_header_tab">
      <div class="search-box">
        <van-icon name="arrow-left" v-show="!display.orderTab" @click="backToAll" />
        <searchInput class="search-input-box"  placeholder="按订单号或商品名称搜索全部订单" :input.sync="searchInput"></searchInput>
        <self-button type="default" no-min-width @on-click="searchOrder">搜索</self-button>
      </div>
      <div class="order-type-box" v-show="display.orderTab">
        <van-tabs v-model="active" color="#45C5DA" title-active-color="#45C5DA" @change="changeTab">
          <van-tab title="全部" name="0"></van-tab>
          <van-tab title="待付款" name="1"></van-tab>
          <van-tab title="待收货" name="4"></van-tab>
          <van-tab title="已完成" name="7"></van-tab>
          <van-tab title="待评价" name="5"></van-tab>
          <van-tab title="已取消" name="19"></van-tab>
        </van-tabs>
      </div>
    </div>
    <van-pull-refresh v-model="downloading" :style="{height:listHeight,overflow:'auto'}" class="order-list-box" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
        :offset="50"
      >
        <div class="order-list-item" v-for="(item, index) in orderList" :key="index">
          <!--dinf-->
          <div class="order-item-box" @click="gotoOrderDetail(item)">
            <div class="order-supplierName">
              <i class="iconfont icon-gongyingshang" style="margin-right: 5px"></i>
              <span>{{ item.supplierName }}</span>
              <div class="delete-icon-box" v-show="item.orderStatus==5 ||item.orderStatus==7"@click.stop="openDeleteOrder(item)" >
                <van-icon class="delete-order-icon" name="delete" />
              </div>
              <span class="order-status" :style="{ color: color(item.orderStatus) }">
                {{ item.orderStatus | getStatus }}
              </span>
            </div>
            <!--多个商品时只显示图片-->
            <div class="more-goods" v-if="item.orderGoodsList.length > 1">
              <div class="goods-img" v-for="(pic, picIndex) in item.picList" :key="picIndex" v-if="showImgNum > picIndex">
                <img v-bind:src="pic.url" alt="" v-lazy="pic.url" />
                <div class="item-goods-num">{{pic.num}}</div>
              </div>
              <van-icon name="ellipsis" v-show="item.picList.length >= showImgNum" />
            </div>
            <!--单个商品时显示图片和商品信息-->
            <div class="one-goods" v-if="item.orderGoodsList.length === 1">
              <div class="goods-img">
                <img v-bind:src="item.goodsDetail.picUrl" v-lazy="item.goodsDetail.picUrl" alt="" />
              </div>
              <div class="goods-info">
                <span class="over2line">{{ item.goodsDetail.goodsName }}</span>
                <span>{{ item.goodsDetail.goodsSpecificationNameValue }}</span>
              </div>
            </div>
            <!--底部信息，商品数量和价格-->
            <div class="bottom-info">
            <span class="goods-price"
            >实付金额:
              <goods-price :price="item.goodsPrice" :main-size="16" style="display: inline-block;"></goods-price>
            </span>
              <span class="goods-num">共{{ item.num }}件商品</span>
            </div>
          </div>
          <!--底部再次购买-->
          <div class="operate-box">
            <self-button type="default" @on-click="buyAgain(item)" v-show="item.orderStatus==5 ||item.orderStatus==7 || item.orderStatus == 19">再次购买</self-button>
            <self-button type="default" @on-click="gotoPay(item.orderSn)" v-show="item.orderStatus == 1">去付款</self-button>
            <self-button type="primary" @on-click="gotoEvaluate(item)" v-show="item.orderStatus==5" >去评价</self-button>
            <self-button type="default" color="#f90" @on-click="confirmReceipt(item)" v-show="item.orderStatus == 4">确认收货</self-button>
            <self-button type="primary" @on-click="openCancelOrder(item)" v-show="item.orderStatus == 1">取消订单</self-button>
            <self-button type="primary" @on-click="gotologistics(item)" v-show="item.orderStatus >= 4 && item.orderStatus!==19 && item.orderStatus!==21">查看物流</self-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-loading class="data-loading" color="#45C5DA" v-show="display.showLoading" />
    <div class="backc-to-top" v-show="display.showBackBtn" @click="backToTop"></div>
    <!--删除订单确认框-->
    <van-dialog
      v-model="display.deleteOrder"
      show-cancel-button
      message="确认删除此订单吗"
      bind:close="onClose"
      :use-title-slot="true"
      @cancel="closeDialog"
      @confirm="deleteCart"
    >
      <template v-slot:title>
        <van-icon name="warning-o" color="#f2270c" size="40" />
      </template>
    </van-dialog>
    <!--取消订单确认框-->
    <van-dialog
      v-model="display.cancelOrder"
      show-cancel-button
      message="确认取消此订单吗"
      bind:close="onClose"
      :use-title-slot="true"
      @cancel="closeDialog"
      @confirm="cancelOrder"
    >
      <template v-slot:title>
        <van-icon name="warning-o" color="#f2270c" size="40" />
      </template>
    </van-dialog>
  </div>
</template>

<script>
import searchInput from 'components/search-input';
import api from 'api/user';
import { orderStatus } from 'common/js/commonVariables';
import gotopay from "common/js/mixin/gotopay";
import { Dialog } from 'vant';
export default {
  mixins: [gotopay],
  components: {
    searchInput,
  },
  data() {
    return {
      display:{
        showLoading: false,
        showBackBtn: false,
        orderTab: true,
        deleteOrder: false, //删除订单确认框
        cancelOrder: false
      },
      searchInput: '',
      active: '4',
      page: {
        pageSize: 5,
        pageNumber: 1,
      },
      statusId: 0,
      orderList: [], //订单列表
      loading: false, //是否在加载
      downloading: false, //是否在加载
      finished: false, //是否已加载全部
      showImgNum: 3, //多个商品时，展示的商品图片数量（针对不同尺寸）
      listHeight:0,//列表高度
      selectedOrder:{}
    };
  },
  computed: {
    //不同的状态颜色
    color() {
      return function(status) {
        switch (status) {
          case 1:
            return '#f2270c';
          case 2:
          case 3:
          case 4:
            return '#07c160';
        }
        return '#999';
      };
    },
  },
  created() {
    this.statusId = this.$route.query.type || '0';
    this.active = this.statusId.toString();
    this.getOrder();
    this.$forceUpdate();
  },
  mounted() {
    //设置盒子高度
    this.$refs['order'].style.height = window.innerHeight + 'px';

    //设置返回顶部图标的显隐切换，使用IntersectionObserver构造函数
    this.observe = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.display.showBackBtn = true;
      } else {
        this.display.showBackBtn = false;
      }
      this.$forceUpdate();
    });
  },
  methods: {
    //计算列表高度,必须在组件加载完成后计算
    loadHeaderSuccess() {
      this.$nextTick(() => {
        const headerHeight = document.getElementsByClassName('title-header')[0].offsetHeight;
        const tabHeight = this.$refs['order_header_tab'].offsetHeight;
        this.listHeight = window.innerHeight - headerHeight - tabHeight + 'px';
      });
    },
    //返回至个人中心
    goback() {
      this.$router.push({
        name: 'mine'
      })
    },
    //搜索订单
    searchOrder() {
      let params = {
        key:this.searchInput,
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
      };
      this.display.orderTab = false;
      api.getOrderByName(params)
        .then(res=>{
          console.log(res);
        })
    },
    //返回至所有订单
    backToAll(){
      this.display.orderTab = true;
      this.getOrder();
    },
    //获取订单
    async getOrder() {
      this.display.showLoading = true;
      let orderStatusId = this.statusId;
      switch (this.statusId) {
        case '0':
          orderStatusId = null;
          break
        case '7': // 5，7都是已完成
          orderStatusId = '5,7'
          break;
      }
      let params = {
        orderStatusId,
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
      };
      const data = await api.getOrders(params);
      this.display.showLoading = false;
      //是否是最后的数据了
      if (data.records.length < this.page.pageSize) {
        this.finished = true;
      }else{
        this.finished = false;
      }
      //是否是上拉加载，是则拼接，放在这里可以避免上拉刷新时没有数据而白屏
      if (this.page.pageNumber === 1) {
        this.orderList = data.records;
      } else {
        this.orderList = this.orderList.concat(data.records);
      }
      this.loading = false;
      this.downloading = false;
      this.orderList.map(order => {
        order.picList = [];
        //如果订单商品多于一个，则只展示商品图片
        if (order.orderGoodsList.length > 1) {
          let supplierId = order.orderGoodsList[0].supplierId,
            judge = true;
          order.picList = order.orderGoodsList.map(item => {
            if (item.supplierId !== supplierId) judge = false;
            return {
              url:item.picUrl,
              num:item.num
            };
          });
          //如果这几个商品是同一供应商下的，则展示供应商，否则展示‘万点上选’
          order.supplierName = judge ? order.orderGoodsList[0].supplierName : '万点上选';
        } else if (order.orderGoodsList.length === 1) {
          order.goodsDetail = order.orderGoodsList[0]; //如果只有一件商品，则展示商品信息
          order.supplierName = order.orderGoodsList[0] ? order.orderGoodsList[0].supplierName : '';
        }
      });
      if (this.orderList.length > 4) {
        this.$nextTick(function() {
          //终止对所有目标元素可见性变化的观察
          this.observe.disconnect();
          this.observe.observe(document.getElementsByClassName('order-list-item')[4]);
        });
      }
    },
    //切换订单状态筛选
    async changeTab(name) {
      // 把滚动条移动最顶部，防止上拉加载问题
      var dom = document.getElementsByClassName('order-list-box');
      dom[0].scrollTop = 0;
      this.statusId = name;
      this.page.pageNumber = 1;
      this.getOrder();
    },
    //下拉刷新
    onRefresh() {
      this.page.pageNumber = 1;
      this.orderList = [];
      this.finished = false;
      this.getOrder();
    },
    //加载
    onLoad() {
      this.page.pageNumber++;
      this.getOrder();
    },
    //前往订单详情
    gotoOrderDetail(item) {
      this.$router.push({
        path: '/order-detail',
        query: { orderSn: item.orderSn },
      });
    },
    //再次购买
    async buyAgain(item){
      let params = item.orderGoodsList.map(goods=>{
        return {
          num: goods.num,
          productId: goods.productId,
        }
      })
      await api.saveCart(params);
      this.$router.push({
        name:'shopCart'
      })
    },
    //前往评价
    gotoEvaluate(item){
      const goodsList = item.orderGoodsList.map(goods=>{
        return {
          goodsName: goods.goodsName,
          picUrl: goods.picUrl,
          productId: goods.productId,
          goodsId: goods.goodsId,
          orderGoodsId: goods.id,
          orderStatusId: goods.orderStatusId
        }
      })
      this.$router.push({
        path:'/evaluate',
        query: {
          goodsList: JSON.stringify(goodsList)
        }
      })
    },
    //打开删除订单对话框
    openDeleteOrder(item) {
      this.display.deleteOrder = true;
      this.selectedOrder = item;
    },
    //关闭删除订单确认框
    closeDialog(){
      this.display.deleteOrder = false;
      this.display.cancelOrder = false;
    },
    //删除订单
    async deleteCart() {
      this.display.deleteOrder = false;
      await api.deleteOrder(this.selectedOrder.orderSn);
      this.$toast({
        type:'success',
        message:'删除订单成功'
      })
      this.page.pageNumber = 1;
      this.getOrder()
    },
    //确认收货
    confirmReceipt(item) {
      Dialog.confirm({
        title: '是否确认收货！',
      }).then(() => {
        api.changeOrderStatus({
          orderStatus: 5,
          orderSn: item.orderSn
        })
          .then(res=>{
            this.getOrder()
            this.$toast('确认收货成功')
          })
      }).catch(() => {
        // on cancel
      });
      return

    },
    //打开取消订单模态框
    openCancelOrder(item) {
      this.display.cancelOrder = true;
      this.selectedOrder = item;
    },
    //取消订单
    cancelOrder() {
      api.changeOrderStatus({
        orderStatus: 19,
        orderSn: this.selectedOrder.orderSn
      })
        .then(res=>{
          this.getOrder()
          this.$toast('取消订单成功')
        })
    },
    //前往物流
    gotologistics(item) {
      this.$router.push({
        path: '/logistics',
        query: {
          orderSn: item.orderSn,
        }
      })
    },
    //返回顶部
    backToTop(){
      document.getElementsByClassName('order-list-box')[0].scrollTop = 0;
    }
  },
  filters: {
    getStatus(val) {
      if (val === 7)val = 5
      return orderStatus[val];
    },
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.order-container {
  .order-header {
    background: #fff;
    .search-box {
      display: flex;
      padding: 5px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid $light-line-color;
      .search-input-box{
        flex: 1;
        margin: 0 5px;
      }
    }
    .order-type-box {
      background: #fff;
    }
  }
  //订单item
  .order-list-item {
    margin: 15px;
    padding: 10px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
    .goods-img {
      position: relative;
      display: inline-block;
      width: 75px;
      height: 75px;
      margin-right: 10px;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
      .item-goods-num{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 20px;
        height: 16px;
        text-align: center;
        line-height: 18px;
        background: rgba(0,0,0,.5);
        font-size: 13px;
        color: #fff;
      }
    }
    .order-supplierName {
      margin-bottom: 5px;
      color: $lingt-word-color;
      .order-status {
        float: right;
        font-size: 14px;
        color: $light-color;
      }
      .delete-icon-box{
        display: flex;
        float: right;
        width: 20px;
        height: 20px;
        margin-left: 5px;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: #eaeaea;
        .delete-order-icon{
          font-size: 16px;
          color: #000;
        }
      }
    }
    .one-goods {
      display: flex;
      align-items: center;
      .goods-info {
        flex: 1;
        font-size: 15px;
        color: $weight-word-color;
      }
    }
    .bottom-info {
      display: flex;
      flex-direction: row-reverse;
      align-items: baseline;
      margin-top: 5px;
      color: $light-color;
      font-size: 13px;
      .goods-num {
        font-size: 12px;
      }
      .goods-price {
        margin-left: 10px;
        color: $lingt-word-color;
      }
    }
    .operate-box{
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      padding: 5px 5px 0;
      border-top: 1px solid $light-line-color;
      .operate-btn{
        display: flex;
        justify-content: center;
        min-width: 70px;
        margin-left: 8px;
        padding: 5px 10px;
        font-size: 13px;
        background: $theme-color;
        color: #fff;
        border-radius: 5px;
        box-sizing: border-box;
      }
      .evaluate-btn{
        background: #fff;
        color: $theme-color;
        border: 1px solid $theme-color;
      }
      .delete-order-btn{
        background: #fff;
        color: $red-color;
        border: 1px solid $red-color;
      }
      .confirm-btn{
        background: #f90;
      }
      .cancel-btn{
        background: #fff;
        color: $theme-color;
        border: 1px solid #e8e8e8;
      }
    }
  }
  .backc-to-top {
    position: fixed;
    right: 10px;
    bottom: 60px;
    width: 35px;
    height: 35px;
    background: url('../../assets/backtotop.png') no-repeat center/cover;
  }
}
</style>
